import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import UserSettings from '@gik/user-profile/components/UserSettings/UserSettings';
import ClaimedItems from '@gik/user-profile/components/ClaimedItems/ClaimedItems';
import UserPagesSection from '@gik/user-profile/components/UserPages/UserPagesSection';
import SavedArticlesSection from '../SavedArticles/SavedArticlesSection';
import SavedProductsSection from '../SavedProducts/SavedProductsSection';
import { LayoutAside } from '@gik/ui';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';
import { userStoreApi, useUserStore } from '@gik/core/store/UserStore';
import { loginOrSignup } from '@gik/auth/utils/auth';
import { navigateTo } from '@/utils/environment';

const blockName = 'user-profile';

export interface IUserSettingsContainer {}

export default function UserSettingsContainer() {
  const bem = bemBlock(blockName);
  const isMd = useBreakpoint(Breakpoint.MD);
  const { id: userId, isReady } = useUserStore(state => ({
    id: state.id,
    isReady: state.isReady,
  }));

  React.useEffect(() => {
    if (isReady && !userId) {
      loginOrSignup({
        onCancel: () => {
          const userId = userStoreApi.getState().id;
          if (!userId) {
            navigateTo('/');
          }
        },
      });
    }
  }, [userId, isReady]);

  if (isMd) {
    return (
      <div className={bem('wrapper')}>
        <LayoutAside asideWidth="328px" gutter="2rem" className={bem()}>
          <aside>
            <UserSettings />
            <SavedArticlesSection />
            <SavedProductsSection />
          </aside>
          <main>
            <UserPagesSection />
            <ClaimedItems />
          </main>
        </LayoutAside>
      </div>
    );
  }

  return (
    <div className={bem()}>
      <section className={bem('mobile-panel')}>
        <UserSettings />
        <UserPagesSection />
        <ClaimedItems />
        <SavedArticlesSection />
        <SavedProductsSection />
      </section>
    </div>
  );
}
